module.exports = __webpack_public_path__ + "resources/img/404-top.7e116428.png";